import { getPokerAB } from '@/components/images/base64/PokerAB';
import { getPokerMin } from '@/components/images/base64/PokerMin';
import { memo } from 'react';
type PokerOwnProps = {
    n: number;
    scale?: number;
    opacity?: number;
    type?: PokerType;
};
type PokerProps = PokerOwnProps;
export enum PokerType {
    Common,
    AndarBahar1,
    AndarBahar2,
}
export const Poker = memo(function Poker(props: PokerProps) {
    const { n, type = PokerType.Common } = props;
    switch (type) {
        case PokerType.AndarBahar1:
            return getPokerAB(n);
        case PokerType.Common:
        case PokerType.AndarBahar2:
        default:
            return getPokerMin(n);
    }
});
